var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubtract = function SvgSubtract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AE955F",
    d: "M10 1.667a8.333 8.333 0 1 1 0 16.665 8.333 8.333 0 1 1 0-16.665M7.798 5.454a.404.404 0 0 0-.397.41v3.97H6.97a.758.758 0 1 0 0 1.514H7.4v.923h-.527a.673.673 0 0 0-.662.684c0 .378.296.684.662.684H7.4v1.252c0 .227.178.41.397.41h.662a.54.54 0 0 0 .529-.546v-1.116h2.913a.673.673 0 0 0 .661-.684.673.673 0 0 0-.661-.684H8.989v-.923h2.183c.944 0 1.44.014 2.168-.503.728-.518 1.206-1.536 1.206-2.519 0-1.586-1.244-2.872-2.778-2.872zm3.572 1.337c.877 0 1.588.629 1.588 1.535 0 .907-.577 1.507-1.454 1.507H8.99V6.791z"
  })));
};
export default SvgSubtract;